import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { List, ListParams } from '../types/main';
import { AdjustCredit, Credit } from '../types/items';
import { transformList } from './transformer';
import { AdjustCreditResponse, TransferCreditRequest } from '../store/modules/credits/types';

class CreditService {
  private route = apis.credits;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api
    .get<List<Credit>>(this.route.list, params)
    .then(transformList);

  adjustCredit = (userId: number, payload: AdjustCredit) => this.api
    .post<AdjustCreditResponse>(this.route.adjustCredits(userId), payload);

  transferCredit = (userId: number, payload: TransferCreditRequest) => this.api
    .post<AdjustCreditResponse>(this.route.transferCredits(userId), payload);
}

export default new CreditService(apiService);
